import React from 'react';
import Header from "../thema/tema1/component/Header";
import Footer from "../thema/tema1/component/Footer";
import SideMenu from "../thema/tema1/component/SideMenu";
import PageContext from "../thema/tema1/component/PageContext";
import Properties from "../const/Properties";
import CustomTable from "../thema/tema1/component/CustomTable"
import CustomModal from "../thema/tema1/component/CustomModal"
import axios from 'axios';
import FaturaPopup from "./FaturaPopup";
import muhasebeFirma from "./MuhasebeFirma";
const durumlar = {
    1: "Araç Limana Giriş Yaptı",
    2: "Ek Bilgi Girişi Yapıldı",
    3: "Ücret Belirlendi",
    4: "Ücret Alındı",
    5: "Gemiye Yüklendi",
};
const gidecegiUlkeEnum = {
    0: "BELİRLENMEDİ",
    1: "TRİESTE",
    2: "BARİ",
};
const active = {Home: "active"};
const bankalar = {
    0: "BELİRLENMEDİ",
    1: "ZİRAAT",
    2: "İŞ BANKASI"
};
const urunler = {
    0: "ÜRÜN SEÇ",
    1: "GEMİ ÜCRETİ",
    2: "UÇAK ÜCRETİ",
    3: "ETS",
    4: "EK SÜRÜCÜ",
    5: "YANICI",
    6: "SİGORTA",
    7: "YOL GEÇİŞ ÜCRETİ",
    8: "ENS",
    9: "BAF",
    10: "ŞOFÖR ÜCRETİ",
    11: "XRAY",
    12: "REZERVASYON ÜCRETİ",
    13: "LİMAN ÜCRETİ",
    14: "FORKLİFT ÜCRETİ",
};
class Gider extends React.Component {
    componentDidMount() {

    }
    constructor(props){
        super(props);
        if(localStorage.getItem("token")=="")
        {
            window.location = '/';
            return false;
        }
        this.state = {
            firmaAdi: "",
            firmaTelefon: "",
            firmaAdres: "",
            contents: [],
            muhasebefirmalar:[],
            firmalar:[],
            content:[],
            pageCount:0,
            totalRow:0,
            startRow:0,
            endRow:0,
            silId:0,
            duzenleId:0,
            silModal:'none',
            title:["PLAKA","GİDECEĞİ ÜLKE","DURUM","İŞLEMLER"],
            showDuzenle:false,
            duzenle:false,
            error: 0
        };
        this.muhasebefirmaDoldur();
        this.handlePageClick({selected:0});
        this.getTotalRow();
    }
    muhasebefirmaDoldur = () => {
        axios({
            method: 'get',
            url: Properties.baseUrl + '/muhasebefirma/getAll',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                let muhasebefirmalar = [];
                for (let i = 0; i < res.data.length; i++) {
                    muhasebefirmalar[res.data[i].id] = res.data[i].firmaAdi;
                }
                this.setState({muhasebefirmalar: muhasebefirmalar});

            })
    }
    onChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }
    setSil = (e)=>{
        this.setState({silId:e.id});
    }
    setDuzenle = (e)=>{
        this.setState({firmaAdi:e.firmaAdi});
        this.setState({firmaTelefon:e.firmaTelefon});
        this.setState({firmaAdres:e.firmaAdres});
        this.setState({duzenleId:e.id});
        this.setState({showDuzenle:true});
    }
    geri = (e)=>{
        this.setState({firmaAdi:""});
        this.setState({firmaTelefon:e.firmaTelefon});
        this.setState({firmaAdres:e.firmaAdres});
        this.setState({showDuzenle:false});
    }
    silModal = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/fatura/delete/'+this.state.silId,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
        .then(res => {
            this.getTotalRow();
            this.handlePageClick({selected:0});
            window.successful("Fatura Silindi");
        }).catch(res =>{
            window.unsuccessful("Fatura Silinemedi.");
    });
        window.disableModal();
    }
    save = e => {
        let status = true;
        if(status)
        {
            axios({
                method: 'post',
                url:  Properties.baseUrl+'/firma/save',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization" : "Bearer " + localStorage.getItem("token")
                },
                data: {
                    firmaAdi: this.state.firmaAdi,
                    firmaTelefon: this.state.firmaTelefon,
                    firmaAdres: this.state.firmaAdres,
                    id:(this.state.showDuzenle?this.state.duzenleId:0)
                }
            })
                .then(res => {
                    this.getTotalRow();
                    this.handlePageClick({selected:0});
                    window.successful((this.state.showDuzenle?"Firma Güncellendi.":"Firma Kaydedildi"));
                    this.setState({firmaAdi:""});
                    this.setState({firmaTelefon:""});
                    this.setState({firmaAdres:""});
                }).catch(res =>{
                    window.unsuccessful((this.state.showDuzenle?"Firma Güncellenemedi.":"Firma Kaydedilemedi."));
            });
            if(this.state.showDuzenle)
                this.setState({showDuzenle:false});
        }
    }
    getTotalRow = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/tasima/toplam/',
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                this.setState({totalRow:res.data});
                this.setState({pageCount:res.data/10});
            });
    }
    durumGuncelle = (id,durum) => {
        this.setState({makbuzId:id});
        this.setState({makbuzDurum:durum});
    }
    handlePageClick=e=>{
        this.setState({ startRow: (e.selected*10)+1});
        this.setState({ endRow:((e.selected+1)*10)});
        axios({
            method: 'get',
            url: Properties.baseUrl+'/tasima/sayfaliGetirMuhasebe/'+e.selected,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                var getData = [];
                res.data.forEach(function (eleman) {
                    var elemanIc = new Object;
                    elemanIc.id = eleman.id;
                    elemanIc.cekiciPlaka = eleman.cekiciPlaka;
                    elemanIc.tarih = eleman.tarih;
                    getData.push(eleman);
                });
                this.setState({tasimalar:getData});
                let content = getData.map((item) =>
                    (<tr>
                        <td>{item.cekiciPlaka}</td>
                        <td>{gidecegiUlkeEnum[item.gidecegiUlke]}</td>
                        <td>{durumlar[item.durum]}</td>
                        <td>
                            <div className="row">
                                <div className="col-3">
                                    <button type="button" onClick={e => this.faturaGiris(item.id)}
                                            className="btn btn-block btn-outline-info">FATURA GİRİŞ
                                    </button>
                                </div>
                                <div className="col-3">
                                    <button type="button" onClick={e => this.durumGuncelle(item.id, 6)}
                                            className="btn btn-block btn-outline-primary"
                                            data-toggle="modal"
                                            data-target="#kayit-modal">KAYDI KAPAT
                                    </button>
                                </div>
                            </div>


                        </td>
                    </tr>));
                this.setState({content: content});
            });
    }
    faturaGiris = (e) => {
        const key = Date.now();
        const newContents = <FaturaPopup key={key} tasimaId={e}></FaturaPopup>;
        this.setState({contents: newContents});
        window.openModal("fatura-modal");
    }
    render(props) {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header/>
                <SideMenu gider="active" muhasebe="menu-is-opening menu-open"  muhasebeacik={{display:'Block'}}/>
                <PageContext>
                    <div className="card">
                        <div className="card-header">
                        </div>
                        <div className="card-body">
                            <CustomTable state={this.state} getTotalRow={this.getTotalRow}
                                         handlePageClick={this.handlePageClick}></CustomTable>
                        </div>
                    </div>
                </PageContext>
                <Footer/>
                <CustomModal id={"modal-default"} funcModal={this.silModal} title={"Faturayı Sil"}
                             content={"Faturayı Silmek İstediğinizden Emin Misiniz?"}></CustomModal>
                <CustomModal buyuk={"true"} altbuton={"true"} id={"fatura-modal"}  funcModal={this.all} title={"FATURA GİRİŞİ"}
                             content={this.state.contents}></CustomModal>

            </div>);
    }
}


export default Gider;
